import { render, staticRenderFns } from "./NewsPage.vue?vue&type=template&id=302b5168&scoped=true"
import script from "./NewsPage.vue?vue&type=script&lang=js"
export * from "./NewsPage.vue?vue&type=script&lang=js"
import style0 from "./NewsPage.vue?vue&type=style&index=0&id=302b5168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302b5168",
  null
  
)

export default component.exports